import { showToast } from '@bp/ui-components';

export function showSuccessToast(text: string, autoClose = 2000) {
  showToast(text, {
    autoClose,
    type: 'success',
  });
}
